const popup = () => {
    const allPopups = document.querySelectorAll('.popup');
    
    allPopups.forEach(pop => {

        const popCloseBut = pop.querySelector('.popup__close');
        const popCloseButThx = pop.querySelector('.popup__thx-button');
        pop.addEventListener('click', (event) => {
            if(event.target == pop || event.target == popCloseBut || event.target == popCloseButThx){
                pop.classList.remove('active');
                document.querySelector('.wpcf7-response-output').style.display = 'none';
            }
        });

    });
}

module.exports = popup;